import request from "../utils/request";


const schemeApi = {
    SchemeList: 'classify/group',
    TransferPage: "classify/group/page",
    PatientInfo: 'patientInfo'
}
export function addGroup(parameter) {
    return request({
        url: schemeApi.SchemeList,
        method: "post",
        data: parameter,

    })
}

export function getGroup({ type, page, size, need_page, invisible }) {
    return request({
        url: schemeApi.SchemeList,
        method: "get",
        params: {
            type,
            page,
            size,
            need_page,
            invisible
        },

    })
}

export function deleteGroupApi(id) {
    return request({
        url: schemeApi.SchemeList + '/' + id,
        method: "delete",

    })
}


export function TransferGroup(obj) {
    return request({
        url: schemeApi.TransferPage,
        method: "post",
        data: obj,
    })
}

export function getPatientInfo(obj) {
  return request({
    url: schemeApi.PatientInfo,
    method: 'get',
    params: obj
  })
}
